import React, { useState } from "react";
import PatientRegForm from "./PatientRegForm";
import PatientList from "./PatientList";

const Patient = () => {
  const [doctors, setDoctors] = useState([]);
  const [centers, setCenters] = useState([]);
  return (
    <>
      <PatientRegForm
        doctors={doctors}
        setDoctors={setDoctors}
        centers={centers}
        setCenters={setCenters}
      />
      <PatientList
        doctors={doctors}
        setDoctors={setDoctors}
        centers={centers}
        setCenters={setCenters}
      />
    </>
  );
};

export default Patient;
